import { Component, Input, OnInit, ViewChild, ElementRef, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ai-medical-summary',
  templateUrl: './ai-medical-summary.component.html',
  styleUrls: ['./ai-medical-summary.component.css']
})
export class AiMedicalSummaryComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() summaryData: any;
  @ViewChild('summaryBody') summaryBodyRef: ElementRef<HTMLDivElement>;

  hasMoreBelow = false;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    // give the DOM a moment to render content, then check
    setTimeout(() => this.checkScroll(), 150);
  }

  ngOnDestroy(): void {}

  close(): void {
    this.activeModal.dismiss();
  }

  onBodyScroll(): void {
    this.checkScroll();
  }

  checkScroll(): void {
    const el = this.summaryBodyRef?.nativeElement;
    if (!el) return;
    // true when there's at least 20px of content still below the viewport
    this.hasMoreBelow = el.scrollHeight - el.scrollTop - el.clientHeight > 20;
  }

  scrollDown(): void {
    const el = this.summaryBodyRef?.nativeElement;
    if (el) el.scrollBy({ top: 200, behavior: 'smooth' });
  }

  /** Returns true if clinical_priority is urgent */
  get isUrgentReferral(): boolean {
    return this.summaryData?.clinical_priority === 'URGENT_REFERRAL';
  }

  /** Returns icon name based on finding keyword */
  getRedFlagIcon(finding: string): string {
    const f = (finding || '').toLowerCase();
    if (f.includes('oxygen') || f.includes('saturation')) return 'O₂';
    if (f.includes('temp')) return '🌡️';
    if (f.includes('breath') || f.includes('respir')) return '🫁';
    return '⚠️';
  }

  isMorning(med: any): boolean { return !!med?.mrng; }
  isAfternoon(med: any): boolean { return !!med?.aftr; }
  isEvening(med: any): boolean { return !!med?.evng; }
  isNight(med: any): boolean { return !!med?.night; }
}
